export const ROUTE_ALIAS_MAP = {
  "/": "/dashboard",
  "/index": "/dashboard",
  "/home": "/dashboard",
  "/user": "/users",
  "/admin/users": "/users",
  "/department": "/departments",
  "/admin/departments": "/departments",
  "/menu": "/menus",
  "/admin/menus": "/menus",
  "/permission": "/permissions",
  "/admin/permissions": "/permissions",
  "/wechat/pay-config": "/wechat/pay-configs",
  "/wechat/pay-configs": "/wechat/pay-configs",
  "/wechat/onboarding": "/wechat/onboardings",
  "/wechat/sub-merchant-onboardings": "/wechat/onboardings",
  "/wechat/mp-pay-order": "/wechat/mp-pay-orders",
  "/wechat/mp-pay-orders": "/wechat/mp-pay-orders",
  "/apifactory": "/apifactory",
  "/api-factory": "/apifactory",
  "/apifactory/cy-table": "/apifactory/table-query",
  "/apifactory/table-query": "/apifactory/table-query",
  "/logs/operation": "/logs/operation",
  "/log/operation": "/logs/operation",
  "/system/operation-log": "/logs/operation",
  "/logs/api-calls": "/logs/api-calls",
  "/log/api-calls": "/logs/api-calls",
  "/system/api-call-log": "/logs/api-calls",
  "/h5/mp-pay-order": "/h5/mp-pay-orders",
  "/h5/mp-pay-orders": "/h5/mp-pay-orders",
  "/h5/onboarding": "/h5/onboardings",
  "/h5/onboardings": "/h5/onboardings",
  "/h5/wechat/mp-pay-orders": "/h5/mp-pay-orders",
  "/h5/wechat/onboardings": "/h5/onboardings",
  "/h5/index": "/h5/home",
  "/h5/dashboard": "/h5/home",
  "/h5/home": "/h5/home"
};

export const VALID_ROUTE_PATHS = new Set([
  "/dashboard",
  "/users",
  "/departments",
  "/menus",
  "/permissions",
  "/wechat/pay-configs",
  "/wechat/onboardings",
  "/wechat/mp-pay-orders",
  "/apifactory",
  "/apifactory/table-query",
  "/logs/operation",
  "/logs/api-calls",
  "/h5/home",
  "/h5/mp-pay-orders",
  "/h5/onboardings"
]);
